
import Home from "./Pages/Home"
import Contact from "./Pages/Contact"
import Project from "./Pages/Project"
import Skills from "./Pages/Skills"
import Github from "./Github/Github"
import About  from "./Pages/About"
import Footer from './Pages/Footer'
// import Simple from "./components/ChakraNav"
import './App.css';
// import Simple from "./components/ChakraNav"

function App() {
  return (
    <div className="App">
         {/* <Simple/> */}
        <Home/>
        <About/>
        <Skills/>
        <Github/>
        <Project/>
     
        <Contact/>
        <Footer/>
        
    </div>
  );
}

export default App;
